import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=6d84a0d5&scoped=true&"
import script from "./Timer.vue?vue&type=script&lang=ts&"
export * from "./Timer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84a0d5",
  null
  
)

export default component.exports